import { Role } from "../../../../app/services/roles.service";

export interface IAppConfigurationConditions {
  country?: Country | Country[];
  environment?: string | string[];
  role?: Role;
  role_any?: string | Role[];
  role_match?: string | Role[];
}

export interface IAppConfiguration {
  country?: Country | Country[];
  environment?: string | string[];
  feature: string;
  feature_version?: string;
  release_version?: string;
  host_name?: string;
  options?: any;
  role_match?: string | Role[];
  role_any?: string | Role[];
  role?: Role;
  includes?: IAppConfigurationConditions;
  excludes?: IAppConfigurationConditions;
  in_rollout?: boolean;
}

export declare type Environment = "Development" | "Quality" | "Production";

export declare type Country =
  | "MX"
  | "US"
  | "CO"
  | "GB"
  | "DE"
  | "IL"
  | "ES"
  | "PA"
  | "PE"
  | "PR"
  | "CR"
  | "FR"
  | "NI"
  | "PL"
  | "SV"
  | "LV"
  | "DO"
  | "GT"
  | "CZ"
  | "PH"
  | "NO"
  | "SE"
  | "EG"
  | "AE"
  | "HR";

export interface RouteGuardAppConfigurationOptions {
  name: string;
  fallbackUrl?: any[];
}
